import React from 'react';
import { Alert, Button, message } from 'antd';
import moment from 'moment';

import { useDismissTaxAlertMutation, useMarkFilingSentMutation } from 'hooks/features/hkdBooks/mutations';
import { useTaxAlertsQuery } from 'hooks/features/hkdBooks/queries';
import { usePermissions } from 'hooks/usePermissions';

const SEVERITY_RANK = { MEDIUM: 1, HIGH: 2, CRITICAL: 3 };
const ALERT_TYPE_BY_SEVERITY = { MEDIUM: 'warning', HIGH: 'warning', CRITICAL: 'error' };

function pickHighestSeverity(alerts) {
  return alerts.reduce((highest, alert) => {
    if (!highest) return alert;

    return (SEVERITY_RANK[alert.severity] || 0) > (SEVERITY_RANK[highest.severity] || 0) ? alert : highest;
  }, null);
}

function TaxFilingBanner() {
  const { can } = usePermissions();
  const canView = Boolean(can('viewTaxFilingReminder'));
  const { alerts } = useTaxAlertsQuery({ enabled: canView });
  const markSentMutation = useMarkFilingSentMutation();
  const dismissMutation = useDismissTaxAlertMutation();

  const alert = pickHighestSeverity(alerts);

  if (!canView || !alert) return null;

  const dueDisplay = alert.due_date ? moment(alert.due_date).format('DD/MM/YYYY') : '';
  const isEmphasised = alert.severity === 'HIGH' || alert.severity === 'CRITICAL';

  const handleMarkSent = () => {
    markSentMutation.mutate(
      {
        period_from: alert.period_from,
        period_to: alert.period_to,
        frequency: alert.frequency,
        due_date: alert.due_date,
      },
      {
        onSuccess: () => message.success('Đã đánh dấu nộp tờ khai thuế.'),
        onError: () => message.error('Không thể đánh dấu đã nộp. Thử lại sau.'),
      }
    );
  };

  const handleDismiss = () => {
    dismissMutation.mutate(alert.id);
  };

  return (
    <div className="mb-4">
      <Alert
        type={ALERT_TYPE_BY_SEVERITY[alert.severity] || 'warning'}
        showIcon
        closable
        onClose={handleDismiss}
        message={
          <div className="flex flex-wrap items-center justify-between gap-3">
            <span className={isEmphasised ? 'font-semibold' : ''}>
              {alert.period_label} · Hạn nộp {dueDisplay}
            </span>
            <Button size="small" type="primary" loading={markSentMutation.isPending} onClick={handleMarkSent}>
              Đánh dấu đã nộp
            </Button>
          </div>
        }
      />
    </div>
  );
}

export default TaxFilingBanner;
